import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight, Check, Loader2 } from 'lucide-react';

const Wizard = ({ 
  steps, 
  currentStep, 
  onNext, 
  onPrev, 
  onSubmit, 
  children,
  canProceed = true,
  isSubmitting = false
}) => {
  const isLastStep = currentStep === steps.length - 1;
  const isFirstStep = currentStep === 0;

  return (
    <div className="space-y-6">
      {/* Progress Bar */}
      <div className="space-y-3">
        {/* Step Indicators */}
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center flex-1">
              <div className="flex flex-col items-center flex-1">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all ${
                    index < currentStep
                      ? 'bg-emerald-600 text-white'
                      : index === currentStep
                      ? 'bg-emerald-600 text-white ring-4 ring-emerald-100'
                      : 'bg-gray-200 text-gray-500'
                  }`}
                >
                  {index < currentStep ? (
                    <Check className="h-5 w-5" />
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>
                <span
                  className={`text-xs mt-2 text-center font-medium ${
                    index === currentStep ? 'text-emerald-700' : 'text-gray-500'
                  }`}
                >
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`h-1 flex-1 mx-2 transition-all ${
                    index < currentStep ? 'bg-emerald-600' : 'bg-gray-200'
                  }`}
                  style={{ marginTop: '-25px' }}
                />
              )}
            </div>
          ))}
        </div>

        {/* Current Step Description */}
        <div className="text-center">
          <p className="text-sm text-gray-600">
            Étape {currentStep + 1} sur {steps.length}
            {steps[currentStep].description && (
              <span className="block text-xs text-gray-500 mt-1">
                {steps[currentStep].description}
              </span>
            )}
          </p>
        </div>
      </div>

      {/* Step Content */}
      <div className="min-h-[300px] py-4">
        {children}
      </div>

      {/* Navigation Buttons */}
      <div className="flex items-center justify-between border-t pt-4">
        <Button
          type="button"
          variant="outline"
          onClick={onPrev}
          disabled={isFirstStep}
          className="min-w-[120px]"
        >
          <ChevronLeft className="h-4 w-4 mr-2" />
          Précédent
        </Button>

        {!isLastStep ? (
          <Button
            type="button"
            onClick={onNext}
            disabled={!canProceed || isSubmitting}
            className="bg-emerald-600 hover:bg-emerald-700 min-w-[120px]"
          >
            Suivant
            <ChevronRight className="h-4 w-4 ml-2" />
          </Button>
        ) : (
          <Button
            type="button"
            onClick={onSubmit}
            disabled={!canProceed || isSubmitting}
            className="bg-emerald-600 hover:bg-emerald-700 min-w-[120px]"
            data-testid="wizard-submit-btn"
          >
            {isSubmitting ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Enregistrement...
              </>
            ) : (
              <>
                <Check className="h-4 w-4 mr-2" />
                Enregistrer
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Wizard;
